import { Stack, Typography } from "@mui/material";
import { ConfirmCancelButtons } from "@smartrr/shared/customerPortal/components/ConfirmCancelButtons";
import { typedLocalize, typedLocalizeKey } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";
import { Trans } from "react-i18next";
import { toast } from "react-toastify";

import { CustomerAction } from "@customer-app/state/typedCustomerRedux";
import { useSmartrrCustomerDispatch } from "@customer-app/state/typedCustomerReduxHooks";

import { RedeemIncentiveOTPProps } from ".";
import { LoyaltyStoreAccess } from "../../../../store";
import { IncentiveColoredImage } from "../../../IncentiveColoredImage";

export const RedeemIncentiveOTPConfirmation = ({ incentive, closeIncentivesModal }: RedeemIncentiveOTPProps) => {
  const actions = LoyaltyStoreAccess.useActions();
  const isLoading = LoyaltyStoreAccess.useIsLoading();
  const { symbol: currencySymbol } = LoyaltyStoreAccess.useCurrency();
  const incentiveCostSuffix = LoyaltyStoreAccess.useSuffix(incentive.costInPoints);
  const dispatch = useSmartrrCustomerDispatch();

  const redeemIncentive = async () => {
    const response = await actions.otp.redeem.incentive(incentive);
    if (response.result === "success") {
      const info = response.data;
      if (info.orgPoints !== null && info.orgPoints !== undefined) {
        dispatch({
          type: "UPDATED_CUSTOMER_LOYALTY_POINTS",
          payload: {
            points: info.orgPoints,
          },
        } as CustomerAction<"UPDATED_CUSTOMER_LOYALTY_POINTS">);
      }
    } else {
      toast.error(response.message);
    }
  };

  return (
    <React.Fragment>
      <Stack alignItems="center" justifyContent="center" py="30px" spacing="10px">
        {incentive.priceRule.type === "fixed_amount" ? (
          <Typography variant="h3" sx={{ marginBottom: 0 }}>
            {typedLocalize("loyalty.redeemIncentiveAmount", {
              amount: -incentive.priceRule.value,
              unitName: currencySymbol,
            })}
          </Typography>
        ) : (
          <Typography variant="h3" sx={{ marginBottom: 0 }}>
            {typedLocalize("loyalty.redeemIncentivePercentage", {
              amount: -incentive.priceRule.value,
              unitName: "%",
            })}
          </Typography>
        )}
        <IncentiveColoredImage incentive={incentive} />
        <Typography variant="body1">
          <Trans
            i18nKey={typedLocalizeKey("loyalty.redeemDeduction")}
            components={[<React.Fragment key={0} />, <strong key={1} />, <React.Fragment key={2} />]}
            values={{
              amount: incentive.costInPoints,
              unitName: incentiveCostSuffix,
            }}
          />
        </Typography>
      </Stack>
      <ConfirmCancelButtons
        isLoading={isLoading}
        onCancel={closeIncentivesModal}
        onConfirm={redeemIncentive}
        disabled={isLoading}
        cancelTextOverride={"general.cancelBtn"}
        confirmTextOverride={"general.confirmBtn"}
      />
    </React.Fragment>
  );
};
